import axios from 'axios';
import { CURRENT_ENVIRONMENT } from 'environment';

const axiosInstance = axios.create({
  baseURL: CURRENT_ENVIRONMENT.baseUrl,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong'),
);

export default axiosInstance;
